export enum CategoryType {
  ALL_PURCHASES = "allPurchases",
  ALL_FOREIGN_PURCHASES = "allForeignPurchases",
  GAS = "gas",
  CENEX_GAS = "gas.cenex",
  GAS_COSTCO = "gas.costco",
  EV_CHARGING = "gas.evCharging",
  DINING = "dining",
  TAKEOUT_DELIVERY = "dining.takeoutDelivery",
  UBEREATS = "dining.takeoutDelivery.ubereats",
  DOORDASH = "dining.takeoutDelivery.doordash",
  DRUGSTORE = "drugstore",
  CVS = "drugstore.cvs",
  WALGREENS = "drugstore.walgreens",
  FITNESS = "fitness",
  SELF_CARE = "selfCare",
  COSMETIC_BARBER_HAIR_SALONS = "selfCare.cosmeticBarberHairSalons",
  MEDICAL_EXPENSES = "medicalExpenses",
  GROCERY = "grocery",
  WHOLESALE_CLUB = "wholesaleClub",
  COSTCO = "costco",
  WALMART = "walmart",
  TARGET = "target",
  HOME_IMPROVEMENT = "homeImprovement",
  ACE_HARDWARE = "homeImprovement.aceHardware",
  LOWES = "homeImprovement.lowes",
  HOME_DEPOT = "homeImprovement.homeDepot",
  MENARDS = "homeImprovement.menards",
  HOME_FURNISHINGS = "homeFurnishings",
  IKEA = "homeFurnishings.ikea",
  POTTERY_BARN = "homeFurnishings.potteryBarn",
  WILLIAMS_SONOMA = "homeFurnishings.williamsSonoma",
  RESTORATION_HARDWARE = "homeFurnishings.restorationHardware",
  CRATE_AND_BARREL = "homeFurnishings.crateAndBarrel",
  BED_BATH_BEYOND = "bedBathBeyond",
  ELECTRONICS = "electronics",
  APPLE = "electronics.apple",
  BEST_BUY = "electronics.bestBuy",
  MICROSOFT_STORE = "microsoftStore",
  DIGITAL_MICROSOFT_STORE = "digitalMicrosoftStore",
  COMPUTER_SERVICES = "computerServices",
  OFFICE_SUPPLIES = "officeSupplies",
  BUSINESS_CONSULTING_SERVICES = "businessConsultingServices",
  ONLINE_ADVERTISING = "onlineAdvertising",
  INTERNET_CABLE_PHONE = "internetCablePhone",
  TELECOMMUNICATIONS = "telecommunications",
  VERIZON = "telecommunications.verizon",
  PHONE_PLANS = "phonePlans",
  BILLS_AND_UTILITIES = "billsAndUtilities",
  STREAMING = "streaming",
  DISNEY_PLUS = "streaming.disneyplus",
  DISNEY_PLUS_HULU_ESPN = "entertainment.disneyPlusHuluEspn",
  ENTERTAINMENT = "entertainment",
  LIVE_ENTERTAINMENT = "entertainment.liveEntertainment",
  DISNEY = "entertainment.disney",
  DISNEY_US_LOCATIONS = "entertainment.disney_us_locations",
  AIRLINE = "travel.airline",
  ALASKA_AIRLINES = "travel.airline.alaska",
  AMERICAN_AIRLINES = "travel.airline.american",
  DELTA_AIRLINES = "travel.airline.delta",
  FRONTIER_AIRLINES = "travel.airline.frontier",
  HAWAIIAN_AIRLINES = "travel.airline.hawaiian",
  JETBLUE_AIRLINES = "travel.airline.jetblue",
  SOUTHWEST_AIRLINES = "travel.airline.southwest",
  UNITED_AIRLINES = "travel.airline.united",
  BRITISH_AIRWAYS = "travel.airline.britishAirways",
  AIR_FRANCE_KLM = "travel.airline.airFranceKlmFlyingBlue",
  AIR_CANADA = "travel.airline.airCanadaAeroplan",
  SKYTEAM_AIRLINES = "travel.airline.skyteamAirlines",
  BREEZE_AIRWAYS = "travel.airline.breeze",
  AER_LINGUS_AIRLINES = "travel.airline.aerLingus",
  IBERIA_AIRLINES = "travel.airline.iberia",
  LEVEL_AIRLINES = "travel.airline.level",
  SPIRIT_AIRLINES = "travel.airline.spirit",
  ANA_AIRLINES = "travel.airline.ana",
  AVIANCA = "travel.airline.avianca",
  CATHAY_PACIFIC = "travel.airline.cathayPacific",
  EMIRATES = "travel.airline.emirates",
  KOREAN_AIR = "travel.airline.korean",
  LATAM = "travel.airline.latam",
  LUFTHANSA = "travel.airline.lufthansa",
  AIR_DOLOMITI = "travel.airline.airDolomiti",
  AUSTRIAN_AIRLINES = "travel.airline.austrianAirlines",
  BRUSSELS_AIRLINES = "travel.airline.brusselsAirlines",
  CROATIA_AIRLINES = "travel.airline.croatiaAirlines",
  EUROWINGS = "travel.airline.eurowings",
  LOT_POLISH_AIRLINES = "travel.airline.lotPolishAirlines",
  VIRGIN_AIRLINES = "travel.airline.virgin",
  LUXAIR = "travel.airline.luxair",
  SWISS_INTERNATIONAL_AIR_LINES = "travel.airline.swissInternationalAirLines",
  TRAVEL = "travel",
  TRANSIT = "travel.transit",
  RENTAL_CAR = "travel.rentalCar",
  RIDESHARE = "travel.rideshare",
  UBER = "travel.rideshare.uber",
  LYFT = "travel.rideshare.lyft",
  CRUISE = "travel.cruise",
  ROYAL_CARIBBEAN = "travel.cruise.royalCaribbean",
  CARNIVAL_CRUISE = "travel.cruise.carnival",
  NORWEGIAN_CRUISE = "travel.cruise.norwegian",
  HOTEL = "travel.hotel",
  BEST_WESTERN = "travel.hotel.bestWestern",
  CHOICE_HOTELS = "travel.hotel.choiceHotels",
  HILTON = "travel.hotel.hilton",
  HYATT = "travel.hotel.hyatt",
  IHG = "travel.hotel.ihg",
  MARRIOTT = "travel.hotel.marriott",
  WYNDHAM = "travel.hotel.wyndham",
  BASS_PRO_CABELAS = "sportingGoods.bassProAndCabelas",
  SPORTS_EQUIPMENT = "sportsEquipment",
  LL_BEAN = "sportsEquipment.llBean",
  REI_COOP = "sportsEquipment.reiCoop",
  RECREATION_LEISURE = "recreationLeisure",
  CRAFTS_HOBBIES = "craftsHobbies",
  GARDENING_FLORAL = "gardeningFloral",
  PET_PURCHASES = "petPurchases",
  CHEWY = "petPurchases.chewy",
  ONLINE_SHOPPING = "onlineShopping",
  PAYPAL = "onlineShopping.paypal",
  AMAZON = "onlineShopping.amazon",
  WAYFAIR = "onlineShopping.wayfair",
  GAP_INC = "onlineShopping.gapInc",
  THRIFT_STORES = "thriftStores",
  DEPARTMENT_STORES = "departmentStores",
  MACYS = "departmentStores.macys",
  NORDSTROM = "departmentStores.nordstrom",
  KOHLS = "departmentStores.kohls",
  DILLARDS = "departmentStores.dillards",
  QVC = "qvc",
  ANTHROPOLOGIE = "anthropologie",
  BARNES_AND_NOBLE = "barnesAndNoble",
  BOOKSTORES = "bookstores",
  LULULEMON = "lululemon",
  AUTOMOTIVE = "automotive",
  CHARITY = "charity",
  SHIPPING = "shipping",
  ROTATING_QUARTERLY_REWARDS = "rotating_quarterly_rewards",
  HOUSING = "housing",
  RENT = "rent",
  CAPITAL_VACATIONS = "capitalVacations",
  RCI = "rci",
  MOBILE_WALLET = "allPurchases.mobileWallet",
  APPLE_PAY = "allPurchases.mobileWallet.applePay",
}

export type CategoryTypeValue = keyof typeof CategoryType;
